import { apiGet, apiPost } from '../../api/api-configuration';
import { failureAction, getAuthorizationAccessToken } from '../../app-actions';
import {
  API_GET_SCT_CUSTOMER_DATA_ENDPOINT,
  API_INITIATE_GET_SCT_CUSTOMER_DATA,
  API_COMPLETE_GET_SCT_CUSTOMER_DATA,
  COMPLETE_SCT_CALLBACK_REQUEST,
  SCT_CALLBACK_REQUEST_ENDPOINT,
  INITIATE_SCT_CALLBACK_REQUEST,
  SCT_AUTO_SAVE_ENDPOINT,
  API_SCT_INITIATE_AUTO_SAVE,
  API_SCT_COMPLETE_AUTO_SAVE,
} from '../../app-constants';

export const successActionSCTCustomerData = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_GET_SCT_CUSTOMER_DATA, data };
};

export const getSCTCustomerData = data => (dispatch) => {
  const endpoint = `${API_GET_SCT_CUSTOMER_DATA_ENDPOINT}&value=${encodeURIComponent(window.parent.tcom.researchInsights.appConfig.currentAccount)}`;
  dispatch({ type: API_INITIATE_GET_SCT_CUSTOMER_DATA });
  apiGet(dispatch, endpoint, successActionSCTCustomerData, failureAction, data);
};


export const successfulSubmissionOfSCTRequestCallback = (response) => {
  const { data } = response;
  return { type: COMPLETE_SCT_CALLBACK_REQUEST, data };
};

export const submitSCTRequestCallback = data => (dispatch) => {
  const endpoint = `${SCT_CALLBACK_REQUEST_ENDPOINT}&value=${encodeURIComponent(window.parent.tcom.researchInsights.appConfig.currentAccount)}`;
  dispatch({ type: INITIATE_SCT_CALLBACK_REQUEST });
  apiPost(dispatch, endpoint, successfulSubmissionOfSCTRequestCallback, failureAction, data);
};


export const successfulSubmissionSCTAutoSave = (response) => {
  const { data } = response;
  return { type: API_SCT_COMPLETE_AUTO_SAVE, data };
};

export const submitSCTAutoSave = data => (dispatch) => {
  const endpoint = `${SCT_AUTO_SAVE_ENDPOINT}&value=${encodeURIComponent(window.parent.tcom.researchInsights.appConfig.currentAccount)}`;
  const bearerToken = getAuthorizationAccessToken();
  if (bearerToken !== 'Bearer undefined') {
    dispatch({ type: API_SCT_INITIATE_AUTO_SAVE });
    apiPost(dispatch, endpoint, successfulSubmissionSCTAutoSave, failureAction, data);
  } else {
    dispatch({ type: '' });
  }
};

export const createOptionsForAddressSearchInput = (siteDetails) => {
  const siteAddressData = siteDetails.map(site => (
    {
      displayText: `${site.address} - ${site.status}`,
      itemId: site.siteId,
      optionId: `${site.address} - ${site.status}`,
    }
  ));
  return siteAddressData;
};

export const updateSiteStatus = (optionsData, siteId) => {
  const updatedOptionsData = optionsData.map((optionItem) => {
    let displayText = optionItem.displayText;
    if (optionItem.itemId === siteId) {
      displayText = displayText.replace('Not Reviewed', 'Reviewed');
    }
    return {
      displayText,
      itemId: optionItem.itemId,
      optionId: displayText,
    };
  });
  return updatedOptionsData;
};


const getNumberRangesForService = (numberRanges) => {
  const rangesWithoutSpaces = numberRanges.replace(/ /g, '');
  const numberRangesArr = rangesWithoutSpaces.split('|');
  const formattedNumberRanges = numberRangesArr.map((numRange) => {
    const range = numRange.split('-');
    const numberLen = range[0].length - 4;
    const rangeStartNumber = range[0].slice(2, range[0].length);
    return `0${rangeStartNumber} to 0${rangeStartNumber.slice(0, numberLen)}${range[1]}`;
  });
  return formattedNumberRanges;
};

export const getSiteServiceDetails = (siteDetails, siteId) => {
  const selectedSite = siteDetails.find(site => site.siteId === siteId);
  const siteServiceDetails = selectedSite.siteServiceDetails.map(service => (
    {
      serviceNumber: service.serviceNumber,
      numberRanges: getNumberRangesForService(service.numberRanges),
      avgOutboundCalls: service.avgOutboundCalls,
      avgInboundCalls: service.avgInboundCalls,
      migrateToTipt: service.migrateToTipt,
      migrateToLiberate: service.migrateToLiberate,
      sipChannels: service.sipChannels,
    }
  ));
  return siteServiceDetails;
};

export const prepareAutoSaveDataForSubmit = (sitesData, siteId, quantityData, authorableData) => {
  const siteData = sitesData.find(site => site.siteId === siteId);
  let estimatedTotalTipt = 0;
  let estimatedTotalLiberate = 0;
  let estimatedTotalSitesCosts = 0;

  Object.entries(quantityData).forEach((entry) => {
    const [key, value] = entry;
    if (key.includes('tipt')) {
      estimatedTotalSitesCosts += value * parseInt(authorableData.migrateTiptCost, 10);
    } else if (key.includes('liberate')) {
      estimatedTotalSitesCosts += value * parseInt(authorableData.migrateToLiberateCost, 10);
    }
  });


  const siteServiceDetails = siteData.siteServiceDetails.map((service) => {
    const migrateToTipt = quantityData[`${siteId}-${service.serviceNumber}-tipt`] !== undefined ?
      quantityData[`${siteId}-${service.serviceNumber}-tipt`] : 0;
    const migrateToLiberate = quantityData[`${siteId}-${service.serviceNumber}-liberate`] !== undefined ?
      quantityData[`${siteId}-${service.serviceNumber}-liberate`] : 0;
    estimatedTotalTipt += migrateToTipt;
    estimatedTotalLiberate += migrateToLiberate;
    return {
      serviceNumber: service.serviceNumber,
      migrateToTipt,
      migrateToLiberate,
    };
  });

  const estimatedTotalTiptCost = estimatedTotalTipt * parseInt(authorableData.migrateTiptCost, 10);
  const estimatedTotalLiberateCost = estimatedTotalLiberate * parseInt(authorableData.migrateToLiberateCost, 10);
  const autoSaveSitesData = {
    sitesData: {
      address: siteData.address,
      status: 'Reviewed',
      estimatedTotalTipt: estimatedTotalTiptCost,
      estimatedTotalLiberate: estimatedTotalLiberateCost,
      estimatedTotalSitesCosts,
      siteServiceDetails,
    },
  };

  return autoSaveSitesData;
};

export const populateServiceQuantityDetails = (sitesData) => {
  const quanitityData = {};
  sitesData.forEach((site) => {
    site.siteServiceDetails.forEach((serviceItem) => {
      quanitityData[`${site.siteId}-${serviceItem.serviceNumber}-tipt`] = serviceItem.migrateToTipt;
      quanitityData[`${site.siteId}-${serviceItem.serviceNumber}-liberate`] = serviceItem.migrateToLiberate;
    });
  });

  return quanitityData;
};

export const validatePhoneNumberWithStartLetter = (phoneNumber) => {
  const phoneNumberWithoutSpaces = phoneNumber.replace(/[\s]/g, '');
  const regex = /^\(?([0]{1})\)?([23478]{1})([0-9]{8})$/;
  return regex.test(phoneNumberWithoutSpaces);
};
